import { usePlanIsUncancelable as useIsUncancelable } from "@/components/features/items/edit/plan/_shared/ui/components/plan-attributes/is-uncancelable/hooks";

import { useProductDayTripPlanFormModelContext } from "../../../../context";

export const useDayTripPlanIsUncancelable = () => {
	const { viewModel, onSetViewModel } = useProductDayTripPlanFormModelContext();
	const { isUncancelable } = viewModel;

	return useIsUncancelable({
		isUncancelable,
		onSetViewModel,
	});
};
